import React, { useContext } from 'react';
import { ConfigContext } from './Config';
import { useTranslation } from 'react-i18next';
import { Link as ChakraLink } from '@chakra-ui/react';

/**
 * Format an item URL based on site's language configuration
 * @param {string} itemUuid - The UUID of the item
 * @param {object} i18n - i18n object from useTranslation
 * @param {Array} siteLanguages - Array of language codes supported by the site
 * @returns {string} Properly formatted URL
 */
export const formatItemUrl = (itemUuid, i18n, siteLanguages) => {
  // If there's exactly one language, don't include language prefix
  if (siteLanguages && siteLanguages.length === 1) {
    return `/item-uuid/${itemUuid}`;
  }
  
  // When multiple languages are available, include the language prefix
  return `/${i18n.language}/item-uuid/${itemUuid}`;
};


/**
 * Chakra UI Link component with language-aware URL formatting
 */
export const ItemLinkChakra = ({ itemUuid, children, ...props }) => {
  const config = useContext(ConfigContext);
  const { i18n } = useTranslation();
  
  // Extract site languages from config
  const siteLanguages = config.siteData?.languages || [];
  
  // Generate the appropriate URL
  const url = formatItemUrl(itemUuid, i18n, siteLanguages);
  
  return (
    <ChakraLink href={url} {...props}>
      {children}
    </ChakraLink>
  );
};

